import { useState } from "react";

/** A click-to-copy value chip with "Copied" feedback. Used for guided values
 *  (URL, credentials, phone number, codes) so the learner can paste them. */
export function CopyChip({ label, value }: { label?: string; value: string }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      // Fallback for browsers/contexts without the async clipboard API.
      const ta = document.createElement("textarea");
      ta.value = value;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
      } catch {
        /* ignore */
      }
      document.body.removeChild(ta);
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1500);
  };

  return (
    <button
      type="button"
      className={`copychip ${copied ? "copied" : ""}`}
      onClick={copy}
      title="Click to copy"
    >
      {label && <span className="copychip-label">{label}</span>}
      <span className="copychip-val">{value}</span>
      <span className="copychip-act">{copied ? "Copied \u2713" : "\u2398 Copy"}</span>
    </button>
  );
}
